/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import React from 'react';
import RadiologistInvoiceForm from './RadiologistInvoiceForm';
import BreadCrumbs from '../../core/BreadCrumbs';
import CaseViewLoader from '../../core/Loaders/CaseViewLoaders';
import { useGetRadiologistInvoice } from '../../../hooks/radiologists/useGetRadiologistInvoice';
const BREAD_CRUMBS = [
  { label: 'Radiologist', to: '/user/radiologist-invoice-list' },
  { label: 'Revenue View', to: '/user/radiologist-invoice/view' },
];

const ViewRadiologistInvoice = () => {
  const { data, loading: fetchingDetails } = useGetRadiologistInvoice();

  return (
    <>
      <BreadCrumbs items={BREAD_CRUMBS} />
      <div className="row card">
        <div className="invoices-tabs-card">
          <div className="card-body">
            {fetchingDetails ? (
              <CaseViewLoader />
            ) : (
              <RadiologistInvoiceForm data={data}/>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewRadiologistInvoice;
